// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_6444e049b8--wrapper--QHy2S","button":"_6444e049b8--button--eBKAY","text":"_6444e049b8--text--SCFDt"};